module.exports = __webpack_public_path__ + "static/img/附件四.6c4ba0c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/附件四.jpg
// module id = XSAZ
// module chunks = 1